
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"64","height":"80","ry":"8","fill":"#fff"}}),_c('path',{attrs:{"d":"M10.744 36.384L4.6 40.176v1.392l6.08 3.792.72-.976-5.648-3.504 5.648-3.472zm4.992-2.448l-1.344.144v11.808h1.344v-6.144c.448-.656 1.312-1.392 2.256-1.392 1.008 0 1.472.432 1.472 1.44v6.096h1.344v-6.112c0-1.568-.72-2.496-2.368-2.496a3.416 3.416 0 00-2.704 1.344zm14.96 11.52l-.528-.912a3.4 3.4 0 01-1.616.4c-1.152 0-1.616-.496-1.616-1.424v-5.008h2.752l.176-1.056h-2.928v-2.064l-1.344.16v1.904h-1.936v1.056h1.936v5.024c0 1.472 1.024 2.528 2.832 2.528.8 0 1.68-.224 2.272-.608zm8.448-8.176c-.848 0-1.392.448-1.856 1.12-.256-.864-.88-1.12-1.52-1.12-.848 0-1.376.512-1.824 1.168l-.096-.992h-1.04v8.432h1.232v-6.544c.464-.72.944-1.008 1.472-1.008.608 0 .656.432.656 1.504v6.048h1.248v-6.544c.464-.72.96-1.008 1.472-1.008.608 0 .656.432.656 1.504v6.048h1.232v-6.272c0-1.936-.816-2.336-1.632-2.336zm7.344-3.216h-3.936v1.072h2.592v8.608c0 1.456 1.008 2.32 2.496 2.32.864 0 1.552-.192 2-.432l-.352-.976c-.464.176-.912.288-1.408.288-.816 0-1.392-.304-1.392-1.136zm6.768 2.32l-.656 1.024 5.648 3.472-5.648 3.488.72.992 6.08-3.792v-1.376z"}})])
          )
        }
      }
    